import "./NotesView.css";
import "react-mde/lib/styles/css/react-mde-all.css";
import { useState, useRef, useEffect } from "react";
import { Tag, Button, Textarea, Modal, Card, Grid } from "@geist-ui/react";
import { FaPlus } from "react-icons/fa";
import ReactMarkdown from "react-markdown";
import ReactMde from "react-mde";

import getNotes from "./getNotes";
import getTags from "./getKeyPhrases";

function NotesView() {
  const [notes, setNotes] = useState([]);
  const [showEditor, setEditorView] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const [noteTitle, setNoteTitle] = useState("");
  const [value, setValue] = useState("**Hello world!!!**");
  const [selectedTab, setSelectedTab] = useState("write");
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (isSending) {
      return;
    }
    setIsSending(true);
    getNotes(setNotes, setIsSending);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const sendRequest = async () => {
    setIsSending(true);

    try {
      const res = await getTags(value);
      setIsSending(false);
      console.log(res);
      setValue((prev) => prev + `\r\n\r\n\r\nTags- ${res}`);
    } catch (err) {
      console.log(err);
      setIsSending(false);
    }

    if (isMounted.current) {
      setIsSending(false);
    }
  };

  const editorHandler = (evt) => {
    setEditorView(true);
    const noteId = evt.target.getAttribute("noteId");
    notes.forEach((note) => {
      if (note.id === noteId) {
        setValue(note.description);
      }
    });
    setNoteTitle(evt.target.textContent);
  };

  const closeHandler = (event) => {
    setEditorView(false);
    setNoteTitle("");
    console.log("closed");
  };

  const closeBox = (event) => {
    setShowBox(false);
  };

  const save = async function* (data) {
    // Promise that waits for "time" milliseconds
    const wait = function (time) {
      return new Promise((a, r) => {
        setTimeout(() => a(), time);
      });
    };

    // Upload "data" to your server
    // Use XMLHttpRequest.send to send a FormData object containing
    // "data"
    // Check this question: https://stackoverflow.com/questions/18055422/how-to-receive-php-image-data-over-copy-n-paste-javascript-with-xmlhttprequest

    await wait(2000);
    // yields the URL that should be inserted in the markdown
    yield "https://picsum.photos/300";
    await wait(2000);

    // returns true meaning that the save was successful
    return true;
  };

  return (
    <>
      <Grid.Container gap={2} justify="flex-start" alignItems="center">
        <Grid xs={6}>
          <Card shadow type="lite">
            <Card.Content>
              <Textarea
                placeholder="CREATE NEW: Enter title description"
                value={noteTitle}
                onChange={(e) => setNoteTitle(e.target.value)}
              />
            </Card.Content>
            <Card.Footer>
              <Button
                icon={<FaPlus />}
                type="warning"
                onClick={() => setEditorView(true)}
              >
                Create
              </Button>
            </Card.Footer>
          </Card>
        </Grid>
        <RenderNotes notes={notes} editorHandler={editorHandler} />
        <Grid xs={6} key={1}>
          <Card
            shadow
            className="notesCard"
            key={1}
            noteId={1}
            onClick={showBox}
          >
            <Card.Content noteId={1}>
              How to be good at something? And still not ruin something
            </Card.Content>
            <Card.Footer noteId={1}>
              '#fresh, #awesome, #mood, #life'
            </Card.Footer>
          </Card>
        </Grid>
        <Grid xs={6} key={1}>
          <Card
            shadow
            className="notesCard"
            key={1}
            noteId={1}
            onClick={showBox}
          >
            <Card.Content noteId={1}>
              How to be NOT good at something? And still not ruin something
            </Card.Content>
            <Card.Footer noteId={1}>
              '#fresh, #awesome, #mood, #life'
            </Card.Footer>
          </Card>
        </Grid>
        <Grid xs={6} key={1}>
          <Card
            shadow
            className="notesCard"
            key={1}
            noteId={1}
            onClick={showBox}
          >
            <Card.Content noteId={1}>HOW TO NOT BE AWESOME</Card.Content>
            <Card.Footer noteId={1}>
              '#fresh, #awesome, #mood, #life'
            </Card.Footer>
          </Card>
        </Grid>
      </Grid.Container>
      <Modal
        width="60vw"
        open={showEditor}
        onClose={closeHandler}
        style={{ padding: "10px" }}
      >
        <Modal.Title>Editor</Modal.Title>
        <Modal.Subtitle>
          Editing <b>{noteTitle}</b>
        </Modal.Subtitle>
        <Modal.Content>
          <ReactMde
            value={value}
            onChange={(val) => setValue(val)}
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
            initialEditorHeight="60vh"
            generateMarkdownPreview={(markdown) =>
              Promise.resolve(<ReactMarkdown source={markdown} />)
            }
            childProps={{
              writeButton: {
                tabIndex: -1,
              },
            }}
            paste={{
              saveImage: save,
            }}
          />
        </Modal.Content>
        <Modal.Action passive onClick={() => setEditorView(false)}>
          Cancel
        </Modal.Action>
        <Modal.Action passive onClick={sendRequest}>
          Submit
        </Modal.Action>
      </Modal>

      <Modal
        width="60vw"
        open={showBox}
        onClose={closeBox}
        style={{ padding: "10px" }}
        onClick={() => setShowBox(true)}
      >
        <Modal.Title>Editor</Modal.Title>
        <Modal.Subtitle>
          Editing <b>{noteTitle}</b>
        </Modal.Subtitle>
        <Modal.Content>
          <ReactMarkdown>{note}</ReactMarkdown>
        </Modal.Content>
        <Modal.Action passive onClick={() => setEditorView(false)}>
          Cancel
        </Modal.Action>
        <Modal.Action passive onClick={sendRequest}>
          Submit
        </Modal.Action>
      </Modal>
    </>
  );
}

function RenderNotes({ notes, editorHandler }) {
  return notes.map((note) => {
    const tags = note.tags.map((tag) => {
      return (
        <Tag
          type="secondary"
          invert
          className="notesTag"
          key={`${note.id}-${tag}`}
        >
          <b>{tag}</b>
        </Tag>
      );
    });
    return (
      <Grid xs={6} key={note.id}>
        <Card
          shadow
          className="notesCard"
          onClick={editorHandler}
          key={note.id}
          noteId={note.id}
        >
          <Card.Content noteId={note.id}>{note.title}</Card.Content>
          <Card.Footer noteId={note.id}>{tags}</Card.Footer>
        </Card>
      </Grid>
    );
  });
}

const note = `
# Hello this is section 1

Lorem ipsum dolor sit amet, consectetur adipiscing elit. \r\n
Quam illa ardentis amores excitaret sui! Cur tandem? Certe, nisi\r\n
 voluptatem tanti aestimaretis. Universa enim illorum ratione cum\r\n
tota vestra confligendum puto. Me igitur ipsum ames oportet, non mea,\r\n
si veri amici futuri sumus. Itaque hic ipse iam pridem est reiectus;\r\n
Duo Reges: constructio interrete. Ergo instituto veterum,\r\n
quo etiam Stoici utuntur, hinc capiamus exordium. \r\n
Ergo illi intellegunt quid Epicurus dicat, ego non intellego?\r\n
An dolor longissimus quisque miserrimus, voluptatem non optabiliorem diuturnitas facit?

# Well this seems more like section 2

Quod si ita se habeat, non possit beatam praestare vitam sapientia.\r\n
`;

export default NotesView;
